import "@babel/polyfill";

import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { createI18n } from './i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import '@/fa.config'

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import localStorageHelper from '@/assets/modules/localStorageHelper'
import localStorageStructure from '@/assets/configurations/localStorageStructure'
import Vuex from 'vuex'

import VueBus from 'vue-bus'

import permissionChecker from '@/assets/modules/permissions/permissionChecker'

import VueApollo from 'vue-apollo'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import introspectionQueryResultData from '@/../fragmentTypes.json'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link'
import { ApolloClient } from 'apollo-client'

import moment from 'moment'

import VueTour from 'vue-tour'

import '@/assets/styles/common.css'
import '@/assets/styles/bootstrapEdit.css'
import 'fullcalendar/dist/fullcalendar.css'
import '@/assets/styles/calendarEdit.css'
import '@/assets/styles/tourEdit.css'
require('vue-tour/dist/vue-tour.css')



// Vue env config
const prodEnvs = require('@/../config/prodEnvs')
console.log('env')
console.log(prodEnvs)
console.log(process.env.NODE_ENV)
console.log(!!prodEnvs[process.env.NODE_ENV])
if (!!prodEnvs[process.env.NODE_ENV]) {
  Vue.config.silent = true
  Vue.config.devtools = false
  Vue.config.productionTip = false
}

const prodEnvsWithStaging = Object.assign({}, prodEnvs, { staging: true })
if (prodEnvsWithStaging[process.env.NODE_ENV]) {
  Raven
  .config('https://fdebdbcfcdc04e178020f2df2c56d75e@sentry.kendu.si/14')
  .addPlugin(RavenVue, Vue)
  .install()
}



Vue.component('icon', Icon)

Vue.use(VueBus);
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueTour)

let VM = null

// Check the local storage structure validity.
if (!localStorageHelper.checkStructure()) {
  localStorageHelper.reinitStructure(localStorageStructure)
}

router.beforeEach((to, from, next) => {
  // If no routes were matched, go to 404
  if (!to.name) {
    next({ name: 'Err404' })
    return
  }

  let permissionMatrix = localStorageHelper.getData('user', 'permissions')

  // Check permissions of all it's predecessors.
  if (Object.keys(permissionMatrix).length) {
    for (let m of to.matched) {
      let {permissions} = m.meta
      if (permissions) {
        // If the route is straight up disabled.
        if (permissions.disabled) {
          next({ name: 'Err404' })
        }

        let requirements = Object.assign({}, permissions)
        if (!permissionChecker.checkRequirements(permissionMatrix, requirements)) {
          next({ name: 'ErrPerm' })
        }
      }
    }
  }

  // Everything is ok.
  next(true)
})

router.afterEach((to, from) => {
  window.document.title = to.meta.tabName
})

Vue.config.productionTip = false

// Make a new translator...
Vue.prototype.$locale = {
  change (language) {
    i18n.locale = language
  },
  current () {
    return i18n.locale
  }
}



// Set initial locales...
let { short, long } = localStorageHelper.getLocale()
moment.locale(short)
const i18n = createI18n(long)

// // Setup Apollo
// Fragment matcher
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
})

// Base HHTP link
const httpLink = new HttpLink({
  uri: `${process.env.API_BASE}`
})

// Middleware Link to put an auth header
const middlewareLink = new ApolloLink((operation, forward) => {
  let token = localStorageHelper.getData('user', 'token')
  if (token !== null) {
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      })
    }
  }

  return forward(operation)
})

const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext()
    const { response: { headers, status, errors } } = context

    // Check if queue has to be updated
    if (headers && response.data && response.data.storeMediaPlanEvent) {
      if (VM !== null) {
        let { id } = response.data.storeMediaPlanEvent
        VM.$store.commit('enqueue', id)
      }
    }

    if (headers) {
      let id = headers.get('Request-Id')
      localStorageHelper.logRequest({ id }, 'all')

      if (status != 200 || (response.errors && response.errors.length)) {
        localStorageHelper.logRequest({ id, status }, 'failed')
      }
    }

    return response
  })
})

const apolloClient = new ApolloClient({
  link: middlewareLink.concat(afterwareLink.concat(httpLink)),
  cache: new InMemoryCache({ fragmentMatcher }),
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.use(VueApollo)

let images = {
  icons: {
    leftMenu: {
      arrowUp: require('!!url-loader!@/assets/images/icons/arrow_up.svg'),
      calendar: require('!!url-loader!@/assets/images/icons/calendar.svg'),
      welcome: require('!!url-loader!@/assets/images/icons/dobrodosel.svg'),
      gridGreen: require('!!url-loader!@/assets/images/icons/grid_green.svg'),
      gridGrey: require('!!url-loader!@/assets/images/icons/grid_grey.svg'),
      icArrowDropDown: require('!!url-loader!@/assets/images/icons/ic_arrow_drop_down.svg'),
      leftArrowGreen: require('!!url-loader!@/assets/images/icons/left-arrow-green.svg'),
      leftArrowWhite: require('!!url-loader!@/assets/images/icons/left-arrow-white.svg'),
      listGreen: require('!!url-loader!@/assets/images/icons/list_green.svg'),
      listGrey: require('!!url-loader!@/assets/images/icons/list_grey.svg'),
      logoQwilink: require('!!url-loader!@/assets/images/icons/logo_qwilink.svg'),
      embarrassing: require('!!url-loader!@/assets/images/icons/nerodno.svg'),
      invisible: require('!!url-loader!@/assets/images/icons/nevidno.svg'),
      newspaper: require('!!url-loader!@/assets/images/icons/newspaper.svg'),
      connected: require('!!url-loader!@/assets/images/icons/povezan.svg'),
      connectShop: require('!!url-loader!@/assets/images/icons/povezi_trgovino.svg'),
      trial: require('!!url-loader!@/assets/images/icons/preizkusni_cas.svg'),
      rightArrowGreen: require('!!url-loader!@/assets/images/icons/right-arrow-green.svg'),
      rightArrowWhite: require('!!url-loader!@/assets/images/icons/right-arrow-white.svg'),
      search: require('!!url-loader!@/assets/images/icons/search.svg'),
      webSite: require('!!url-loader!@/assets/images/icons/spletna_stran.svg'),
      visible: require('!!url-loader!@/assets/images/icons/vidno.svg'),
      x: require('!!url-loader!@/assets/images/icons/x.svg'),

      radioButtonOff: require('!!url-loader!@/assets/images/icons/radio_button_grey.svg'),
      radioButtonOn: require('!!url-loader!@/assets/images/icons/radio_button_green.svg'),

      checkBoxOff: require('!!url-loader!@/assets/images/icons/check_box_grey.svg'),
      checkBoxOn: require('!!url-loader!@/assets/images/icons/check_box_green.svg'),

      hamburger: require('!!url-loader!@/assets/images/icons/hamburger.svg'),
      close: require('!!url-loader!@/assets/images/icons/close.svg'),

      logOut: require('!!url-loader!@/assets/images/icons/log_out.svg'),

      spinner: require('!!url-loader!@/assets/images/icons/spinner.svg')
    },

    campaign: {
      dailyDeal: require('!!url-loader!@/assets/images/icons/daily_deal.svg'),
      productPromotion: require('!!url-loader!@/assets/images/icons/product_promotion.svg'),
      quickPost: require('!!url-loader!@/assets/images/icons/quick_post.svg'),
      sale: require('!!url-loader!@/assets/images/icons/sale.svg')
    },

    servicesNav: {
      administration: require('!!url-loader!@/assets/images/serviceIcons/administracija.svg'),
      analytics: require('!!url-loader!@/assets/images/serviceIcons/analitika.svg'),
      bot: require('!!url-loader!@/assets/images/serviceIcons/bot.svg'),
      eMailMarketing: require('!!url-loader!@/assets/images/serviceIcons/e postni_marketing.svg'),
      facebook: require('!!url-loader!@/assets/images/serviceIcons/facebook.svg'),
      google: require('!!url-loader!@/assets/images/serviceIcons/google.svg'),
      informacija: require('!!url-loader!@/assets/images/serviceIcons/informacija net.svg'),
      campaigns: require('!!url-loader!@/assets/images/serviceIcons/kampanje.svg'),
      monitoring: require('!!url-loader!@/assets/images/serviceIcons/monitoring.svg'),
      design: require('!!url-loader!@/assets/images/serviceIcons/oblikovanje.svg'),
      optimization: require('!!url-loader!@/assets/images/serviceIcons/optimizacija.svg'),
      website: require('!!url-loader!@/assets/images/serviceIcons/spletna stran.svg'),
      content: require('!!url-loader!@/assets/images/serviceIcons/vsebine.svg'),
      import: require('!!url-loader!@/assets/images/serviceIcons/import.svg'),

      administrationActive: require('!!url-loader!@/assets/images/serviceIcons/administracija_active.svg'),
      analyticsActive: require('!!url-loader!@/assets/images/serviceIcons/analitika_active.svg'),
      botActive: require('!!url-loader!@/assets/images/serviceIcons/bot_active.svg'),
      eMailMarketingActive: require('!!url-loader!@/assets/images/serviceIcons/e postni_marketing_active.svg'),
      facebookActive: require('!!url-loader!@/assets/images/serviceIcons/facebook_active.svg'),
      googleActive: require('!!url-loader!@/assets/images/serviceIcons/google_active.svg'),
      informacijaActive: require('!!url-loader!@/assets/images/serviceIcons/informacija net_active.svg'),
      campaignsActive: require('!!url-loader!@/assets/images/serviceIcons/kampanje_active.svg'),
      monitoringActive: require('!!url-loader!@/assets/images/serviceIcons/monitoring_active.svg'),
      designActive: require('!!url-loader!@/assets/images/serviceIcons/oblikovanje_active.svg'),
      optimizationActive: require('!!url-loader!@/assets/images/serviceIcons/optimizacija_active.svg'),
      websiteActive: require('!!url-loader!@/assets/images/serviceIcons/spletna stran_active.svg'),
      contentActive: require('!!url-loader!@/assets/images/serviceIcons/vsebine_active.svg'),
      importActive: require('!!url-loader!@/assets/images/serviceIcons/import_active.svg')
    }
  },

  firstTime: {
    connectShop: require('!!url-loader!@/assets/images/firstTime/connectShop.png')
  },

  user: {
    userImage: require('!!url-loader!@/assets/images/logos/qwilink_logo-dark.png')
  },

  logos: {
    light: {
      informacijaNet: require('!!url-loader!@/assets/images/logos/1_informacija_net_white.svg'),
      shopamine: require('!!url-loader!@/assets/images/logos/1_shopamine.png'),
      facebook: require('!!url-loader!@/assets/images/logos/facebook_white.svg'),
      googlePlus: require('!!url-loader!@/assets/images/logos/GooglePlus_white.svg'),
      pinterest: require('!!url-loader!@/assets/images/logos/pinterest_white.svg'),
      twitter: require('!!url-loader!@/assets/images/logos/twitter_white.svg'),
      hitrost: require('!!url-loader!@/assets/images/logos/1_hitrost.png'),
      shopify: require('!!url-loader!@/assets/images/logos/shopify-logo-svg_white.svg'),
      sqwizr: require('!!url-loader!@/assets/images/logos/sqwiz_white.svg'),
      woocommerce: require('!!url-loader!@/assets/images/logos/1_woocommerce.png'),
      wordpressCircle: require('!!url-loader!@/assets/images/logos/wordpress_circle.png')
    },

    coloredBg: {
      informacijaNet: require('!!url-loader!@/assets/images/logos/1_informacija_net.svg'),
      instagram: require('!!url-loader!@/assets/images/logos/1_instagram.png'),
      shopamine: require('!!url-loader!@/assets/images/logos/1_shopamine.png'),
      facebook: require('!!url-loader!@/assets/images/logos/facebook.svg'),
      googlePlus: require('!!url-loader!@/assets/images/logos/GooglePlus.svg'),
      hashtags: require('!!url-loader!@/assets/images/logos/hashtags.svg'),
      pinterest: require('!!url-loader!@/assets/images/logos/pinterest.svg'),
      timezone: require('!!url-loader!@/assets/images/logos/timezone.svg'),
      twitter: require('!!url-loader!@/assets/images/logos/twitter.svg')
    },
    clear: {
      giphy: require('!!url-loader!@/assets/images/logos/giphy.png'),
      hitrost: require('!!url-loader!@/assets/images/logos/1_hitrost.png'),
      shopify: require('!!url-loader!@/assets/images/logos/1_shopify.png'),
      sqwizr: require('!!url-loader!@/assets/images/logos/1_sqwizr.png'),
      woocommerce: require('!!url-loader!@/assets/images/logos/1_woocommerce.png'),
      fbAdsImg: require('!!url-loader!@/assets/images/logos/2_fb_ads.png'),
      googleAdwordsImg: require('!!url-loader!@/assets/images/logos/2_google_adwords.png'),
      googleAnalyticsImg: require('!!url-loader!@/assets/images/logos/2_google_analytics.png'),
      shopifyImg: require('!!url-loader!@/assets/images/logos/2_shopify.png'),
      elasticMail: require('!!url-loader!@/assets/images/logos/elastic_mail.png'),
      fbAds: require('!!url-loader!@/assets/images/logos/fb_ads.png'),
      googleAdwords: require('!!url-loader!@/assets/images/logos/google_adwords.png'),
      googleAnalytics: require('!!url-loader!@/assets/images/logos/google_analytics.png'),
      logoQwilink: require('!!url-loader!@/assets/images/logos/logo_qwilink.svg'),
      mailchimp: require('!!url-loader!@/assets/images/logos/mailchimp.png'),
      logoDark: require('!!url-loader!@/assets/images/logos/qwilink_logo-dark.svg'),
      wordpressCircle: require('!!url-loader!@/assets/images/logos/wordpress_circle.png')
    }
  },

  loginBackground: {
    default: require('!!url-loader!@/assets/images/backgrounds/qwilink_login_icons_small.png')
  }
}

// Vuex
const store = new Vuex.Store({
  state: {
    images,
    normalNotification: null,
    eventNotification: null,

    onboardingChannels: [],
    newConnections: {},

    searchResoults: {},

    permissions: {},

    // Que of events to be published
    eventQueue: [],

    viewType: null
  },
  mutations: {
    setViewType (state, type) {
      state.viewType = type
    },

    refreshQueue (state, events) {
      state.eventQueue = []
      for (let e of events) {
        state.eventQueue.push(e.id)
      }
    },
    enqueue (state, eventId) {
      state.eventQueue = state.eventQueue.filter(eq => eq !== eventId)
      state.eventQueue.push(eventId)
    },
    dequeue (state, eventId) {
      state.eventQueue = state.eventQueue.filter(eq => eq !== eventId)
    },

    setPermissions (state, permissions) {
      state.permissions = permissions
    },

    setSearchResoults (state, searchResoults) {
      state.searchResoults = searchResoults
    },

    addNewConnection (state, connection) {
      state.newConnections[connection] = true
    },
    setOnboardingChannels (state, channels) {
      state.onboardingChannels = channels
    },

    addNotification (state, notificationObject) {
      let { type, notification } = notificationObject

      if (type === 'normal') {
        state.normalNotification = notification
      } else {
        state.eventNotification = notification
      }
    },

    removeNotification (state, type) {
      if (type === 'normal') {
        state.normalNotification = null
      } else {
        state.eventNotification = null
      }
    },

    clearNotifications (state) {
      state.normalNotification = null
      state.eventNotification = null
    }
  },
  getters: {
    isMobileView: state => {
      return state.viewType === 'MOBILE'
    },
    isDesktopView: state => {
      return state.viewType === 'DESKTOP'
    },

    getEventQueue: state => {
      return state.eventQueue
    },

    getPermissions: state => {
      return state.permissions || {}
    },

    searchResoults: state => {
      return state.searchResoults
    },

    newOnboardingConnections: state => {
      return state.newConnections
    },
    onboardingChannels: state => {
      let rtr = state.onboardingChannels
      return rtr
    },

    loginBgs: state => {
      return state.images.loginBackground
    },
    qlogos: state => {
      return state.images.logos
    },
    icons: state => {
      return state.images.icons
    },
    normalNotification: state => {
      return state.normalNotification || {}
    },
    eventNotification: state => {
      return state.eventNotification || {}
    },

    logoDark: state => {
      return state.images.logos.clear.logoDark
    },
    logoShopamine: state => {
      return state.images.logos.logoShopamine
    },
    logoWoocommerce: state => {
      return state.images.logos.logoWoocommerce
    },
    logoShopify: state => {
      return state.images.logos.logoShopify
    },

    logoFacebook: state => {
      return state.images.logos.logoFacebook
    },
    logoTwitter: state => {
      return state.images.logos.logoTwitter
    },
    logoInstagram: state => {
      return state.images.logos.logoInstagram
    },
    logoPinterest: state => {
      return state.images.logos.logoPinterest
    },

    logoGoogleAnalytics: state => {
      return state.images.logos.googleAnalytics
    },
    logoGoogleAdwords: state => {
      return state.images.logos.googleAdwords
    },
    logoFacebookAds: state => {
      return state.images.logos.facebookAds
    },

    logoMailchimp: state => {
      return state.images.logos.logoMailchimp
    },
    logoElasticemail: state => {
      return state.images.logos.logoElasticemail
    },

    connectShop: state => {
      return state.images.firstTime.connectShop
    },

    userImage: state => {
      return state.images.user.userImage
    }
  }
})

// Some extra things...
Date.prototype.addDays = function(days) {
  let dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
}

/* eslint-disable no-new */
VM = new Vue({
  el: '#app',
  router,
  i18n,
  provide: apolloProvider.provide(),
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js